import SmartSearchDateIntervalSelectAndActionsLayout from "../../../components/Layouts/smart-search-date-interval-select-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import {
  GetHistoricalInventoryParams,
  getHistoricalInventory,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import {ValidationEnum} from "../../../enums/validationEnum";

function HistoricalInventory() {
  return (
    <SmartSearchDateIntervalSelectAndActionsLayout
      searchBy={[
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      validations={[
          ValidationEnum.VALIDATE_SMART_SEARCH,
          ValidationEnum.VALIDATE_SEARCH,
      ]}
      validOnEmpty={false}
      onRefresh={(output, params, startDateInterval, endDateInterval) => {
        const getHistoricalInventoryParams: GetHistoricalInventoryParams = {
          name:"Historical Inventory",
          output,
          dateIntervalStart: startDateInterval.format("MM-DD-YYYY"),
          dateIntervalEnd: endDateInterval.format("MM-DD-YYYY"),
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getHistoricalInventoryParams[id] = params.id;
        }

        return getHistoricalInventory(getHistoricalInventoryParams);
      }}
    />
  );
}

export default HistoricalInventory;
